import { getTodayISO } from './dateUtils';
import { totalServicio } from './descuento';
import { semaforo } from '../components/mapa/vistasMapa';

// Estado de un cliente para la lista de Clientes (13-oct-2026), con el mismo idioma que el Mapa
// (semáforo del último service) y que Trabajos (lo abierto y lo que falta cobrar).
const HECHOS = ['COMPLETADO', 'PENDIENTE_FACTURACION', 'FACTURADO', 'COBRADO', 'REALIZADO'];
// Hecho, incluidos los archivados que estaban hechos y los archivados viejos sin ese dato
// (20-oct-2026, misma regla que el backend: SQL_HECHO)
const fueHecho = (s) => HECHOS.includes(s.estado) || (s.estado === 'ARCHIVADO' && (!s.archivadoDesde || HECHOS.includes(s.archivadoDesde)));
const POR_COBRAR = ['COMPLETADO', 'PENDIENTE_FACTURACION', 'FACTURADO'];
const ABIERTOS = ['PRESUPUESTO', 'APROBADO', 'EN_PROGRESO'];

const monto = (s) => (Number(s.montoFinal) > 0 ? Number(s.montoFinal) : Number(totalServicio(s)) || 0);

function hace(iso) {
    if (!iso) return null;
    const [a, m, d] = String(iso).slice(0, 10).split('-').map(Number);
    const [ha, hm, hd] = getTodayISO().split('-').map(Number);
    const meses = (ha - a) * 12 + (hm - m) - (hd < d ? 1 : 0);
    if (meses >= 12) { const n = Math.floor(meses / 12); return `hace ${n} año${n !== 1 ? 's' : ''}`; }
    if (meses >= 1) return `hace ${meses} mes${meses !== 1 ? 'es' : ''}`;
    const dias = Math.round((Date.UTC(ha, hm - 1, hd) - Date.UTC(a, m - 1, d)) / 86400000);
    return dias <= 0 ? 'hoy' : dias === 1 ? 'ayer' : `hace ${dias} días`;
}

export function estadoCliente(cliente, sedes, equipos, servicios) {
    const hoy = getTodayISO();
    const sedesCli = sedes.filter(s => (s.clienteId || s.cliente?.id) === cliente.id);
    const ids = new Set(sedesCli.map(s => String(s.id)));
    const equiposN = equipos.filter(e => ids.has(String(e.sedeId)) && e.activo !== false).length;
    const svs = servicios.filter(s => (s.clienteId || s.cliente?.id) === cliente.id);

    // Último service: un trabajo técnico hecho, nunca uno agendado a futuro (antes contaba
    // presupuestos y visitas que todavía no pasaron y aparecía "Últ: mañana")
    const ultimo = svs.filter(s => s.servicioTipo !== 'VENTA' && fueHecho(s) && s.fecha && String(s.fecha).slice(0, 10) <= hoy)
        .map(s => String(s.fecha).slice(0, 10)).sort().pop() || null;
    const sem = semaforo({ ultimaVisita: ultimo });
    const deuda = svs.filter(s => POR_COBRAR.includes(s.estado)).reduce((t, s) => t + monto(s), 0);
    const abiertos = svs.filter(s => ABIERTOS.includes(s.estado)).length;
    const zona = [cliente.localidad].filter(v => v && v !== 'Sin localidad').join('');
    const esEmpresa = (cliente.clienteTipo || cliente.tipo) === 'EMPRESA';
    // Próximo paso: primero la plata, después el service vencido
    // 2-nov-2026: también se ofrece a los que están por vencer (antes solo a los vencidos)
    const accion = deuda > 0 ? 'cobrar' : (sem === 'rojo' || sem === 'amarillo') && cliente.telefono ? 'ofrecer' : null;
    // Para "atender primero": me deben → service vencido → por vencer → el resto
    const prioridad = deuda > 0 ? 0 : sem === 'rojo' ? 1 : sem === 'amarillo' ? 2 : 3;
    return { ultimo, hace: hace(ultimo), sem, deuda, abiertos, zona, esEmpresa, sedesN: sedesCli.length, equiposN, accion, prioridad };
}

export function mensajeService(cliente, e) {
    const tiempo = e.hace ? e.hace.replace('hace ', '') : null;           // "7 meses", "1 año"
    const paso = tiempo ? `${/^1 /.test(tiempo) ? 'Pasó' : 'Pasaron'} ${tiempo} desde el último service de tu dispenser`
        : 'Hace un tiempo que no le hacemos service a tu dispenser';
    return `Hola ${String(cliente.nombre || '').split(/\s+/)[0]}! Te escribimos de Dispenser La Tienda. ${paso}: `
        + 'limpieza, sanitizado y control. ¿Querés que coordinemos una visita?';
}
